import { render, staticRenderFns } from "./OnBoardingSecondStep.vue?vue&type=template&id=5d4416b2&"
import script from "./OnBoardingSecondStep.vue?vue&type=script&lang=js&"
export * from "./OnBoardingSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingSecondStep.vue?vue&type=style&index=0&id=5d4416b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports